<template>

    <div class="pf"><!--    产出-->
        <el-row>
            <el-col :span="13">
                <el-table class="table" border ref="multipleTable" :data="tableData" :key="tableId" height="447"
                          size="mini" :row-class-name="tableRowClassName" tooltip-effect="dark">
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column :label="$t('form_serial_number')" align="left" type="index" width="40">
                    </el-table-column>
                    <!--<el-table-column
                            align="left"
                            prop="vc_gsname"
                            label="货权公司"
                            width=""
                            show-overflow-tooltip>
                    </el-table-column>-->
                    <el-table-column align="left" prop="vc_pzname" :label="$t('form_product_name')" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column align="left" prop="vc_no" :label="$t('form_batch_number')" width="" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column align="left" prop="vc_unit" :label="$t('form_metering')" width="35" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column align="left" prop="f_require" :label="$t('promanagement_requirement/t')" width="48" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column align="left" prop="f_zx" :label="$t('promanagement_on_line')" width="50" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column align="left" prop="f_zbxs" :label="$t('promanagement_100%_discount')" width="50" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column v-if="i_id==0" align="left" prop="f_innum" :label="$t('promanagement_consume')" width="71">
                        <template slot-scope="scope">
<!--                            <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+'.f_innum'">-->
                                <el-input-number :controls="false" :min="0" :precision="$setPrecision.quantityPrecision" class="" size="mini" style="width: 60px" v-model="scope.row.f_innum" @change="xhChange(scope.row,scope.$index)"></el-input-number>
<!--                            </el-form-item>-->
                        </template>
                    </el-table-column>
                    <el-table-column v-if="i_id!=0" align="left" prop="f_innum" :label="$t('promanagement_consume')" width="">
                    </el-table-column>
                    <el-table-column align="left" prop="f_syzx" :label="$t('promanagement_remaining_online')" width="60" show-overflow-tooltip>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col :span="11">
                <el-form  :model="formData" :inline="true" :rules="formRules" ref="formRef" label-width="90px" size="mini">
                    <el-form-item class="form-title" prop="tasknum" :label="$t('promanagement_task_order_number')" >
                        <el-input  v-model="formData.tasknum" disabled style="width:180px"></el-input>
                    </el-form-item>
                    <el-form-item class="form-title" prop="sctime" :label="$t('promanagement_production_time')" >
                        <el-input  v-model="formData.sctime" disabled style="width:180px"></el-input>
                    </el-form-item>
                    <el-form-item class="form-title" prop="proname" :label="$t('form_finished_goods')" >
                        <el-select v-model="formData.proname" :placeholder="$t('promanagement_please_select_finished_products')"
                                   @change="changePro" filterable required clearable :disabled="edit" style="width:180px">
                            <el-option v-for="one in proList" :key="one.i_id" :label="one.vc_pzname" :value="one.i_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="scnum" :label="$t('promanagement_batch_number')" >
                        <el-input  v-model="formData.scnum" :disabled="edit" @blur="isOnly($event)" style="width:180px">
                        </el-input>
                    </el-form-item>
                    <el-form-item v-if="form.i_type==3" class="form-title" prop="vc_processingvendor" :label="$t('promanagement_entrusted_factory')" >
                        <el-input  v-model="formData.vc_processingvendor" disabled style="width:180px">
                        </el-input>
                    </el-form-item>
                    <el-form-item v-if="form.i_type==3" class="form-title" prop="f_processingfee" :label="$t('promanagement_processing_fee')" >
                        <el-input-number  type="number" :disabled="this.i_id!==0" :controls="false" :precision="2" v-model="formData.f_processingfee" :min="0" style="width:180px">
                        </el-input-number>
                    </el-form-item>
                    <el-form-item class="form-title" prop="ccshul" :label="$t('promanagement_output_quantity')" >
                        <el-input-number :controls="false" :min="0" :precision="$setPrecision.quantityPrecision"
                                         v-model="formData.ccshul" :disabled="edit" @change="ccChange" style="width:180px">
                        </el-input-number>
                    </el-form-item>
                    <el-form-item class="form-title" prop="zbl" :label="$t('promanagement_100%_discount_quantity')">
                        <el-input-number :controls="false" :min="0" :precision="$setPrecision.quantityPrecision"
                                         v-model="formData.zbl" :disabled="edit" @change="zblChange" style="width:180px">
                        </el-input-number>
                    </el-form-item>
                    <el-form-item class="form-title" prop="cjname" :label="$t('form_workshop_department')" >
                        <el-input  v-model="formData.cjname" disabled style="width:180px">
                        </el-input>
                    </el-form-item>
                    <el-form-item class="form-title" prop="banci" :label="$t('promanagement_classes')" >
                        <el-select v-model="formData.banci" :placeholder="$t('promanagement_please_select_a_shift')"
                                   required  :disabled="edit" style="width:180px">
                            <el-option v-for="one in bcOption" :label="one.label" :key="one.value" :value="one.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="scline" :label="$t('promanagement_production_pine')" >
                        <el-select v-model="formData.scline" :placeholder="$t('promanagement_please_select_a_production_line')"
                                   filterable required clearable :disabled="edit" style="width:180px">
                            <el-option v-for="one in lineList" :key="one.i_id" :label="one.vc_name" :value="one.i_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="i_xtype" :label="$t('promanagement_domestic/export_sales')" >
                        <el-select v-model="formData.i_xtype" @change="xslxChange" :placeholder="$t('promanagement_please_select_sales_type')"
                                   required  :disabled="edit" style="width:180px">
                            <el-option v-for="one in nwxOption" :label="one.labelshow" :key="one.value" :value="one.value" style="width:180px">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="other" :label="$t('promanagement_other_attributes')" >
                        <el-input  v-model="formData.other"  :disabled="edit" style="width:180px"></el-input>
                    </el-form-item>

                    <el-form-item class="form-title" prop="i_ischeck" :label="$t('promanagement_do_you_want_to_test_it')">
                        <!--<el-radio v-model="formData.i_ischeck" :label="1" :disabled="edit">是</el-radio>
                        <el-radio v-model="formData.i_ischeck" :label="0" :disabled="edit">否</el-radio>-->
                        <el-radio v-model="formData.i_ischeck" :label="1" disabled>{{$t('form_correct')}}</el-radio>
                        <el-radio v-model="formData.i_ischeck" :label="0" disabled>{{$t('form_deny')}}</el-radio>
                    </el-form-item>

                    <el-form-item class="form-title" prop="i_hystate" :label="$t('promanagement_test_results')" v-if="formData.i_ischeck==1&&edit">
                        <div style="width:180px" :class="[formData.i_hystate==1||formData.i_hystate==2?'lvzt':(formData.i_hystate==-1?'hongzt':'juzt')]">
                            {{formData.i_hystate==0?$t('promanagement_to_be_inspected'):(formData.i_hystate==1?$t('promanagement_qualified'):(formData.i_hystate==-1?$t('promanagement_unqualified'):$t('promanagement_premium_product')))}}</div>

                    </el-form-item>
                    <el-form-item class="form-title smallFont" prop="i_ismustcheck" :label="$t('promanagement_is_it_necessary_to_inspect_unloading')">
                        <el-radio v-model="formData.i_ismustcheck" :label="1" disabled>{{$t('form_correct')}}</el-radio>
                        <el-radio v-model="formData.i_ismustcheck" :label="0" disabled>{{$t('form_deny')}}</el-radio>
                    </el-form-item>
                    <el-form-item class="form-title" prop="i_hystate" :label="$t('promanagement_laboratory_test_report')" v-if="!!formData.vc_hyfile">
<!--                        {{// fileList[0].vc_path}}-->
<!--                        <div v-for="(item,index) in fileList" :key="index">{{index}}</div>-->
                        <el-image style="width: 80px;height: 80px;border: 1px solid #CCCCCC"
                                  v-for="(item,index) in formData.vc_hyfile.otherfiles" :key="index" :src="filehead+item.vc_path"
                                  :preview-src-list="[filehead+item.vc_path]" :z-index="9999">
                        </el-image>
                    </el-form-item>
                    <div>
                        <el-form-item class="form-title dutylog" prop="vc_note" :label="$t('promanagement_on_duty_log')" >
                            <el-input type="textarea"  :rows="2" resize="none"  v-model="formData.vc_note" style="width: 100%">
                            </el-input>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item class="form-title smallFont smallLabelW" prop="vc_lruname" :label="$t('form_creator')" >
                            <div >{{formData.vc_lruname}}</div>
<!--                            <el-input  v-model="formData.vc_lruname" disabled style="width: 120px"></el-input>-->

                        </el-form-item>
                        <el-form-item class="form-title smallFont smallLabelW" prop="date" :label="$t('form_date')" >
                            <div >{{formData.date}}</div>

<!--                            <el-input  v-model="formData.date" disabled style="width: 120px"></el-input>-->

                        </el-form-item>

                        <el-form-item class="form-title smallFont smallLabelW" prop="date" :label="$t('promanagement_accountingTime')" >
                            <div >{{formData.dt_accounttime}}</div>

<!--                            <el-input  v-model="formData.dt_accounttime" disabled style="width: 120px"></el-input>-->
                        </el-form-item>
                    </div>

                </el-form>
<!--                文字显示 -->
                <pre style="font-size: 12px;width: 100%;color: #3e82e8;margin: 0;white-space: pre-wrap;word-wrap: break-word;padding:  0 20px">
                    {{$t('promanagement_instructions')}}
<!--说明:-->
<!--生产批号:唯一不可重复;-->
<!--产出数量:用于库存核算;-->
<!--折百量:用于成本核算;默认折百量=产出数量,半成品、在线产品可按含量折百成对应成品量，用于分摊成本、能耗-->
                </pre>
            </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <el-button type="primary"  size="small" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'">{{$t('button_save')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,file_root} from "@/utils/baseUrl";

    export default {
        name: "ProduceForm",
        props:{
            produce:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                baseerp:"",
                formData:{
                    tasknum:"",
                    sctime:"",
                    proname:"",
                    scnum:"",
                    ccshul:"",
                    zbl:"",
                    cjname:"",
                    banci:"",
                    scline:"",
                    nwx:"",
                    i_xtype:'',
                    other:"",
                    vc_note:"",
                    vc_lruname:sessionStorage.getItem("lruname"),
                    date:"",
                    i_ischeck:0,
                    vc_processingvendor:'',
                    f_processingfee:'0.00',
                },
                proList:[],
                lineList:[],
                bcOption:[
                    {
                        value:"1",
                        label:this.$t('promanagement_day_shift')
                    },
                    {
                        value:"2",
                        label:this.$t('promanagement_night_shift')
                    }
                ],
                nwxOption:[
                    {
                        value:"0",
                        label:'内销',
                        labelshow:this.$t('promanagement_for_the_domestic_market')
                    },
                    {
                        value:"1",
                        label:'外销',
                        labelshow:this.$t('promanagement_for_export')
                    }
                ],
                hyOption:[
                    {
                        value:1,
                        label:this.$t('form_correct')
                    },
                    {
                        value:0,
                        label:this.$t('form_deny')
                    }
                ],
                formRules:{
                    proname:[{required:true,message:this.$t('promanagement_please_select_finished_products'),trigger:"change"},],
                    scnum:[{required:true,message:this.$t('promanagement_please_fill_in_the_production_batch_number'),trigger:"blur"},],
                    ccshul:[{required:true,message:this.$t('promanagement_please_fill_in_the_output_quantity'),trigger:"blur"},],
                    zbl:[{required:true,message:this.$t('promanagement_please_fill_in_the_discount_amount'),trigger:"blur"},],
                    banci:[{required:true,message:this.$t('promanagement_please_select_a_shift'),trigger:"change"},],
                    scline:[{required:true,message:this.$t('promanagement_please_select_a_production_line'),trigger:"change"},],
                    i_xtype:[{required:true,message:this.$t('promanagement_please_choose_domestic_and_international_sales'),trigger:"change"},],
                    //i_ischeck:[{required:true,message:"请选择是否化验",trigger:"change"},],
                },
                edit:false,
                tableData:[],
                i_id:0,
                i_rwid:0,
                i_pzid:0,
                disabled:false,
                pzid:0,
                qpid:0,
                qorder:0,
                gsid:0,
                i_flag:"",
                tableId:"",
                editForm:{},
                form:{},
                syxh:0,
                pageSize:1,
                mid:0,
                dataText:this.$t('tips_data_loading_in_progress'),
                fileList:[],
                filehead:''

            }
        },
        watch: {
            produce: {
                handler() {
                    if (this.produce) {
                        this.pageSize=this.page_size;
                        this.i_id=this.produce.i_id;
                        this.mid=this.produce.i_mid;
                        if (this.produce.i_id==0){
                            this.getDateYYYYMMddHHMMSS();
                            this.form=this.produce.taskDa;
                            let dtnowtime = `${this.produce.taskDa.dt_createtime.slice(0, 4)}-${this.produce.taskDa.dt_createtime.slice(4, 6)}-${this.produce.taskDa.dt_createtime.slice(6, 8)}`;
                            let dtendtime = `${this.produce.taskDa.dt_endtime.slice(0, 4)}-${this.produce.taskDa.dt_endtime.slice(4, 6)}-${this.produce.taskDa.dt_endtime.slice(6, 8)} 23:59:59`;
                            this.i_rwid=this.form.i_id;
                            this.edit=false;
                            this.formData={
                                tasknum:this.form.vc_pno,
                                cjname:this.form.vc_cjname,
                                sctime:this.date,
                                date:this.date,
                                vc_note:'',
                                i_ischeck:0,
                                i_ismustcheck:null,
                                i_hystate:0,
                                vc_lruname:sessionStorage.getItem("lruname"),
                                vc_hyfile:'',
                                dt_accounttime:this.produce.jz==false?dtendtime:dtnowtime,
                                vc_processingvendor:this.form.vc_processingvendor,
                                f_processingfee:this.form.f_processingfee?this.form.f_processingfee:'0.00'

                            };
                            this.getFinishedProductList();
                            this.getSclineList();
                            this.getOnlineStockList();
                            // console.log(this.produce, "this.produce",this.formData);
                        }else {
                            //    编辑
                            this.formRules={};
                            this.editForm=this.produce.value;
                            this.form=this.produce.taskDa;
                            this.edit=true;
                            this.getProduceDetails();
                        }
                    }
                },
                immediate: true,
                deep: true
            }
        },
        mounted() {
            this.filehead=file_root

            this.baseerp=baseerp;
        },
        methods: {
            xslxChange(e){
                this.formData.i_xtype=e;
                this.formData.nwx=this.nwxOption.find(f=>f.value==this.formData.i_xtype).label
                // console.log(this.formData.nwx,'this.formData.nwx')
            },
            //查看
            async getProduceDetails(){
                let param={
                    i_mid:this.mid,
                    i_id:this.editForm.i_id,
                    i_gsid:this.form.i_gsid,
                    i_pzid:this.form.i_pzid,
                };
                let res=await API.getProduceDetails(param);
                if(res.code==1){
                    this.formData={
                        tasknum:res.data.vc_scno,
                        sctime:res.data.dt_tltime,
                        proname:res.data.vc_pzname,
                        scnum:res.data.vc_no,
                        ccshul:res.data.f_outnum,
                        zbl:res.data.f_outnum_zb,
                        cjname:res.data.vc_cjname,
                        banci:res.data.vc_bcno,
                        scline:res.data.vc_scline,
                        nwx:res.data.vc_xtype,
                        i_xtype:res.data.i_xtype.toString(),
                        other:res.data.vc_sx,
                        vc_note:res.data.vc_note,
                        vc_lruname:res.data.vc_lruname,
                        date:res.data.dt_createtime,
                        dt_accounttime:res.data.dt_accounttime,
                        i_ischeck:res.data.i_ischeck,
                        i_ismustcheck:res.data.i_ismustcheck,
                        i_hystate:res.data.i_hystate,
                        vc_hyfile:res.data.vc_hyfile,
                        f_processingfee:res.data.f_processingfee,
                        i_processingvendor:res.data.i_processingvendor,
                        vc_processingvendor:res.data.vc_processingvendor
                    };
                    // if(!!res.data.vc_hyfile){
                    //     this.fileList=res.data.vc_hyfile.otherfiles
                    //     this.fileList.forEach(item=>{
                    //         this.$set(item,'vc_path',this.filehead+item.vc_path)
                    //     })
                    // }
                    if (res.data.details.length==0){
                        this.dataText=this.$t('tips_no_data_available_at_the_moment')
                    }else{
                        this.tableData=res.data.details;
                    }


                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //产成品
            async getFinishedProductList(){
                let param={
                    i_mid:this.mid,
                    i_pzid:this.form.i_pzid,
                    i_gsid:this.form.i_gsid,
                    vc_pricing_unit:this.form.vc_pricing_unit,
                };
                let res=await API.getFinishedProductList(param);
                if(res.code==1){
                    this.proList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //生产线
            async getSclineList(){
                let param={
                    i_mid:this.mid,
                    i_cjid:this.form.i_cjid,
                };
                let res=await API.getSclineList(param);
                if(res.code==1){
                    this.lineList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //生产批次号
            isOnly(event){
                let val=event.target.value;
                // console.log(val);
                if (val??''!==''){
                    this.isExistVcno();
                }
            },
            async isExistVcno(){
                let param={
                    i_mid:this.mid,
                    vc_no:this.formData.scnum,
                };
                let res=await API.isExistVcno(param);
                if(res.code==1){
                }else if(res.code==-1){
                    this.$message.error(this.$t('promanagement_the_production_batch_number_is_not_unique_please_re-enter'));
                    this.formData.scnum='';
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //在线库存
            async getOnlineStockList(){
                let param={
                    i_mid:this.mid,
                    i_rwid:this.form.i_id,
                    i_gsid:this.form.i_gsid,
                    i_cjid:this.form.i_cjid,
                    i_ckid:this.form.i_ckid,
                    i_pzid:this.form.i_pzid,
                };
                let res=await API.getOnlineStockList(param);
                if(res.code==1){
                    if (res.data.length==0){
                        this.dataText=this.$t('tips_no_data_available_at_the_moment')
                    }
                    this.tableData=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            changePro(val){
                // console.log("--gsis",val)
                let obj = this.proList.find(item => item.i_id == val);
                // this.$forceUpdate()
                this.i_flag=obj.i_flag;
                this.i_pzid=obj.i_id;
                //检验
                this.formData.i_ischeck = obj.i_ischeck;
                this.formData.i_ismustcheck = obj.i_ismustcheck;

            },
            ccChange(val){
                // console.log(val,'val')
                this.formData.zbl=val;
                this.zblChange(val);
            },
            zblChange(val){
                this.qpid=null;
                this.qorder=null;
                // console.log(val,'val')
                if (val??''!==''){
                    this.tableData.forEach((item,index)=>{
                        // console.log(index)
                        if (this.tableData[index].f_require==0){
                            this.tableData[index].f_innum=this.tableData[index].f_zx;
                            // console.log("xuqiu0")
                        }else {
                            this.tableData[index].f_innum=this.$math.multiply(this.tableData[index].f_require,this.formData.zbl);
                            // console.log("this.tableData[index].f_innum",this.tableData[index].f_innum)
                            if (this.tableData.length>1){
                                // console.log(item.i_pid,"this.item.i_pid",this.qpid)
                                // console.log(item.i_order,"this.item.i_pid",this.qorder)
                                if (item.i_pid==this.qpid||item.i_order==this.qorder){
                                    /*if (this.syxh>this.tableData[index].f_syzx){
                                        this.tableData[index].f_innum=this.tableData[index].f_syzx;
                                        this.syxh=this.$math.subtract(this.syxh,this.tableData[index].f_syzx);
                                    }else{
                                        this.tableData[index].f_innum=this.syxh;
                                    }*/
                                    // if (this.syxh!==0){
                                        this.tableData[index].f_innum=this.syxh;
                                    // console.log(this.syxh,"syxh")
                                    // }
                                    if (this.tableData[index].f_zx<this.tableData[index].f_innum){
                                        this.syxh=this.$math.subtract(this.tableData[index].f_innum,this.tableData[index].f_zx)
                                        // console.log(this.syxh)
                                        this.tableData[index].f_innum=this.tableData[index].f_zx;
                                    }else{
                                        this.syxh=0
                                    }

                                }else{
                                    // console.log(222222)
                                    // this.tableData[index].f_innum=this.$math.multiply(this.tableData[index].f_require,this.formData.zbl);
                                    if (this.tableData[index].f_zx<this.tableData[index].f_innum){
                                        this.syxh=this.$math.subtract(this.tableData[index].f_innum,this.tableData[index].f_zx)
                                        this.tableData[index].f_innum=this.tableData[index].f_zx;
                                    }else{
                                        this.syxh=0;
                                    }
                                }
                                /*this.tableData[index].f_innum=this.$math.multiply(this.tableData[index].f_require,this.formData.zbl);
                                if (this.tableData[index].f_syzx<this.tableData[index].f_innum){
                                    this.tableData[index].f_innum=this.tableData[index].f_syzx;
                                }else{
                                }*/

                            }else if (this.tableData.length==1){
                                if (this.tableData[index].f_zx<this.tableData[index].f_innum){
                                    this.tableData[index].f_innum=this.tableData[index].f_zx;
                                    }
                                }
                            }

                        let sy=this.$math.subtract(this.tableData[index].f_zx,this.tableData[index].f_innum)
                        this.tableData[index].f_syzx= Math.round(sy*100000)/100000;
                        this.qpid=item.i_pid;
                        this.qorder=item.i_order;
                    })
                    this.tableId=Math.random();
                }
            },
            xhChange(val,index){
                // console.log(val,index,"xh")
                if (this.tableData[index].f_zx<val.f_innum){
                    this.$message.error(this.$t('promanagement_the_consumption_shall_not_exceed_the_online_quantity'))
                    this.tableData[index].f_innum=this.tableData[index].f_zx;
                }
                if (this.tableData[index].f_zx<0){
                    this.tableData[index].f_innum=0;
                }
                this.tableData[index].f_syzx=this.$math.subtract(this.tableData[index].f_zx,this.tableData[index].f_innum);
                this.tableId=Math.random();

            },
            cancel(){
                //console.log(this.pageSize,"------")
                this.visible=false;
                this.$emit('close');

                //this.$emit('getPickingReqList')
            },
            //保存
            async saveForm(){

                // console.log(this.formData.ccshul,"param")
                let details = this.tableData.filter(item=>item.f_innum!=0);
                if (this.formData.proname??''!==''){}else {
                    this.$message.error(this.$t('promanagement_please_select_finished_products'));
                    return ;
                }
                if (this.formData.scnum??''!==''){}else {
                    this.$message.error(this.$t('promanagement_please_fill_in_the_production_batch_number'));
                    return ;
                }
                if (this.formData.ccshul!==''){}else {
                    this.$message.error(this.$t('promanagement_please_fill_in_the_output_quantity'));
                    return ;
                }
                if (this.formData.zbl!==''){}else {
                    this.$message.error(this.$t('promanagement_please_fill_in_the_discount_amount'));
                    return ;
                }
                if (this.formData.banci??''!==''){}else {
                    this.$message.error(this.$t('promanagement_please_select_a_shift'));
                    return ;
                }
                if (this.formData.scline??''!==''){}else {
                    this.$message.error(this.$t('promanagement_please_select_a_production_line'));
                    return ;
                }
                if (this.formData.nwx??''!==''){}else {
                    this.$message.error(this.$t('promanagement_please_choose_domestic_and_international_sales'));
                    return ;
                }
                this.disabled=true;
                let param={
                    i_mid:this.mid,
                    i_id:this.i_id,
                    i_rwid:this.form.i_id,
                    vc_scno:this.formData.tasknum,
                    vc_no:this.formData.scnum,
                    i_gsid:this.form.i_gsid,
                    i_cjid:this.form.i_cjid,
                    i_ckid:this.form.i_ckid,
                    i_pzid:this.i_pzid,
                    i_lruid:sessionStorage.getItem("userid"),
                    vc_lruname:sessionStorage.getItem("lruname"),
                    f_outnum:this.formData.ccshul,
                    f_outnum_zb:this.formData.zbl,
                    i_flag:this.i_flag,
                    vc_note:this.formData.vc_note,
                    vc_bcno:this.formData.banci,
                    vc_scline:this.formData.scline,
                    vc_xtype:this.formData.nwx,
                    i_xtype:Number(this.formData.i_xtype),
                    vc_sx:this.formData.other,
                    details:details,
                    i_ischeck:this.formData.i_ischeck,
                    i_ismustcheck:this.formData.i_ismustcheck,
                    dt_accounttime:this.formData.dt_accounttime,
                    i_type:this.form.i_type,
                    f_processingfee:this.formData.f_processingfee,
                    i_processingvendor:this.form.i_processingvendor,
                };
                // console.log(param,"param")

                let res=await API.saveProduce(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    // this.disabled=true;
                    this.$emit('getConsumeList',this.pageSize)
                    this.cancel();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.date=`${date.getFullYear()}-${month}-${strDate}`;
                //console.log(this.formData.date)
            },
            tableRowClassName({row,rowIndex}){
                //console.log(row.i_gsid,this.gsid)
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                if (row.isother == 1) {
                    return 'danger-row';
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .juzt{
        color: #f08c00;
        font-weight: 600;
    }
    .lvzt{
        color: #3cb44b;
        font-weight: 600;

    }
    .hongzt{
        color: #fa5050;
        font-weight: 600;

    }
.table{
    width: 100%;
}
.el-input-number--mini {
    width: 96px;
    line-height: 26px;
}
/deep/{
    .danger-row{
        color: #999;
    }
    .el-table .cell{
        padding: 0 5px;
    }
    .el-input-number--mini {
        width: 86px;
        line-height: 26px;
    }
    .el-input-number.is-without-controls .el-input__inner {
        padding-left: 5px;
        padding-right: 5px;
    }
    .smallFont{
        .el-form-item__label{
            font-size: 13px;
        }
    }
    .dutylog{
        width: 100%;
        .el-form-item__content{
            width: calc(100% - 90px);
        }
    }
    .smallLabelW{
        .el-form-item__label{
            width: 68px !important;
        }
    }
}
</style>